import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

const AUTH_HEADERS = { authorization: 'authkey xB84JJ89Hd25' };

export default {
  name: 'partial-release-request-tab',
  components: {
    VueElementLoading,
  },
  data() {
    return {
      isLoading: false,
      isLoadingOnHold: false,
      isSubmitting: false,
      userHubId: '',
      userHubName: '',
      userEmail: '',
      requestedShipmentCount: '',
      errorMessage: '',
      successMessage: '',
      onHoldHubs: [],
      onHoldLoadError: '',
      templateInfoMessage: '',
      bulkFailed: [],
      bulkResultMessage: '',
      bulkResults: [],
      showConfirmModal: false,
      confirmMessage: '',
      isBulkUploadMode: true,
      uploadedFile: null,
      uploadedFileName: '',
      // HUB-8284 / HUB-8320: must match listLmHubsOnHold filter and upload isHoldAll
      bulkHoldScope: 'cwb',
    };
  },
  computed: {
    holdScopeLabel() {
      return this.bulkHoldScope === 'holdAll' ? 'Hold all' : 'CWB hold';
    },
  },
  mounted() {
    const userdetailEncrypt = window.localStorage.getItem('userdetail');
    const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    const userdetail = JSON.parse(plaintext);
    this.userEmail = userdetail[0].email;
    this.userHubId = userdetail[0].HubId[0];
    this.resolveHubName();
    this.loadOnHoldHubs();
  },
  methods: {
    apiBase() {
      return apiUrl.api_url_hubops;
    },

    isHoldAllFromScope() {
      return this.bulkHoldScope === 'holdAll';
    },

    onHoldScopeChange() {
      this.loadOnHoldHubs();
    },

    async loadOnHoldHubs() {
      this.isLoadingOnHold = true;
      this.onHoldLoadError = '';
      try {
        const isHoldAll = this.isHoldAllFromScope();
        const res = await axios.get(`${this.apiBase()}listLmHubsOnHold`, {
          headers: AUTH_HEADERS,
          params: { isHoldAll },
        });
        if (res.data && res.data.ResultCode === 100) {
          this.onHoldHubs = res.data.ResponseData || [];
        } else {
          this.onHoldHubs = [];
          this.onHoldLoadError =
            (res.data && res.data.ReturnMessage) || 'Unable to load LM hubs on hold';
        }
      } catch (err) {
        console.error(err);
        this.onHoldHubs = [];
        this.onHoldLoadError = 'Unable to load LM hubs on hold';
      } finally {
        this.isLoadingOnHold = false;
      }
    },

    resolveHubName() {
      this.isLoading = true;
      this.errorMessage = '';
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
        data: { hubids: [this.userHubId] },
        headers: AUTH_HEADERS,
      })
        .then((result) => {
          this.isLoading = false;
          if (
            result.data.ResultCode === 100
            && Array.isArray(result.data.ResponseData)
            && result.data.ResponseData.length > 0
            && result.data.ResponseData[0].HubName
          ) {
            this.userHubName = result.data.ResponseData[0].HubName;
          } else {
            this.errorMessage = 'Unable to resolve hub details for the logged-in user';
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.errorMessage = 'Unable to resolve hub details for the logged-in user';
        });
    },

    async downloadPartialReleaseTemplate() {
      if (this.isLoadingOnHold) {
        return;
      }
      if (this.onHoldLoadError || !this.onHoldHubs.length) {
        await this.loadOnHoldHubs();
      }
      if (this.onHoldLoadError) {
        this.templateInfoMessage = this.onHoldLoadError;
        return;
      }
      const headers = ['Parenthubname', 'Parenthubid', 'Hubname', 'Release_Count'];
      const sampleData = this.onHoldHubs.map((hub) => ({
        Parenthubname: hub.parentHubName || '',
        Parenthubid: hub.parentHubId != null ? hub.parentHubId : '',
        Hubname: hub.hubName,
        Release_Count: '',
      }));

      if (!sampleData.length) {
        this.templateInfoMessage =
          `No hubs on hold for ${this.holdScopeLabel} — template has headers only.`;
      } else {
        this.templateInfoMessage = '';
      }

      const escapeCell = (v) => {
        if (v === null || v === undefined) return '';
        const s = String(v);
        return (/[,"\n]/.test(s)) ? `"${s.replace(/"/g, '""')}"` : s;
      };

      const lines = [];
      lines.push(headers.join(','));
      sampleData.forEach((row) => {
        lines.push(headers.map((h) => escapeCell(row[h])).join(','));
      });

      const csv = lines.join('\r\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', 'PartialReleaseTemplate.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    onBulkUploadSubmit() {
      this.errorMessage = '';
      this.bulkResultMessage = '';
      if (!this.uploadedFile) {
        this.errorMessage = 'Upload file is required.';
        return;
      }
      this.submitBulkUpload();
      const fileInput = document.getElementById('partial-release-upload');
      if (fileInput) fileInput.value = '';
    },
    exportBulkFailed() {
      if (!this.bulkFailed || !this.bulkFailed.length) return;
      const headers = Object.keys(this.bulkFailed[0]);
      const csvRows = [headers.join(',')];
      this.bulkFailed.forEach((row) => {
        const values = headers.map((h) => (`"${(row[h] !== undefined && row[h] !== null) ? String(row[h]).replace(/"/g, '""') : ''}"`));
        csvRows.push(values.join(','));
      });
      const csvContent = csvRows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'partial_release_failed_records.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    isValidCount() {
      const value = Number(this.requestedShipmentCount);
      return Number.isInteger(value) && value > 0;
    },
    clearSelectedFile() {
      this.uploadedFile = null;
      this.uploadedFileName = '';
      const fileInput = document.getElementById('partial-release-upload');
      if (fileInput) {
        fileInput.value = '';
      }
    },
    onFileSelected(event) {
      const file = event && event.target && event.target.files ? event.target.files[0] : null;
      this.uploadedFile = null;
      this.uploadedFileName = '';
      this.errorMessage = '';
      this.successMessage = '';

      if (!file) {
        return;
      }

      if (!/\.csv$/i.test(file.name)) {
        this.errorMessage = 'Please upload a valid .csv file';
        return;
      }

      this.uploadedFile = file;
      this.uploadedFileName = file.name;
    },
    submitBulkUpload() {
      if (!this.uploadedFile || !this.userEmail) {
        this.errorMessage = 'Please select a CSV file to upload';
        this.successMessage = '';
        return;
      }

      this.isSubmitting = true;
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';

      const formData = new FormData();
      formData.append('file', this.uploadedFile);
      formData.append('createdBy', this.userEmail);
      formData.append('isHoldAll', String(this.isHoldAllFromScope()));

      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'partialAcceptLMHold/bulkUpload',
        data: formData,
        headers: {
          ...AUTH_HEADERS,
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((result) => {
          this.isSubmitting = false;
          this.isLoading = false;
          const body = result.data || {};
          const isSuccess = body.ResultCode === 100 || body.resultCode === 100 || body.success === true || body.Success === true;

          this.bulkFailed = (body.Results || body.results || []).filter(
            (r) => (r.Status || r.status) === 'FAILED'
          );
          this.bulkResultMessage = body.ReturnMessage || body.returnMessage || body.Message || '';
          this.bulkResults = body.Results || body.results || [];

          if (isSuccess) {
            this.successMessage = body.ReturnMessage || body.returnMessage || 'Bulk partial release upload submitted successfully.';
            this.clearSelectedFile();
            this.loadOnHoldHubs();
          } else {
            this.bulkResultMessage = body.ReturnMessage || body.returnMessage || 'Bulk partial release upload failed';
            if (!this.bulkFailed.length) this.clearSelectedFile();
          }
        })
        .catch((err) => {
          this.isSubmitting = false;
          this.isLoading = false;
          this.clearSelectedFile();
          this.bulkResults = [];
          const status = err && err.response && err.response.status;
          if (status === 502 || status === 504) {
            this.bulkResultMessage =
              'Upload timed out at the gateway — some rows may have processed. Refresh the list and retry remaining hubs in smaller batches.';
          } else {
            this.bulkResultMessage = 'Bulk partial release upload failed';
          }
        });
    },
    confirmSubmit() {
      if (this.isLoading || this.isSubmitting || !this.userHubName) {
        return;
      }
      if (!this.isValidCount()) {
        this.errorMessage = 'Enter a valid positive shipment count';
        this.successMessage = '';
        return;
      }
      this.confirmMessage = `Are you sure you want to request partial release of ${this.requestedShipmentCount} shipment(s) for this hub?`;
      this.showConfirmModal = true;
    },
    onConfirmProceed() {
      this.showConfirmModal = false;
      this.confirmMessage = '';
      this.submitPartialRelease();
    },
    onConfirmCancel() {
      this.showConfirmModal = false;
      this.confirmMessage = '';
    },
    submitPartialRelease() {
      this.isSubmitting = true;
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';
      const requested = Number(this.requestedShipmentCount);
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'partialAcceptLMHold',
        data: {
          hubId: this.userHubId,
          requestedShipmentCount: requested,
          createdBy: this.userEmail,
        },
        headers: AUTH_HEADERS,
      })
        .then((result) => {
          this.isSubmitting = false;
          this.isLoading = false;
          const body = result.data || {};
          if (body.ResultCode === 100) {
            const bags = body.ReleasedBagCount || 0;
            const ships = body.ReleasedShipmentCount || 0;
            this.successMessage = `Released ${bags} bag(s) totalling ${ships} shipment(s) against requested ${requested}.`;
            this.requestedShipmentCount = '';
            this.loadOnHoldHubs();
          } else {
            this.errorMessage = body.ReturnMessage || 'Partial release request failed';
          }
        })
        .catch(() => {
          this.isSubmitting = false;
          this.isLoading = false;
          this.errorMessage = 'Partial release request failed';
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/CwbHoldRequest/PartialReleaseRequestTab/PartialReleaseRequestTab.js